import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function BUHHistoricalTable({rows,Month1,Month2,Month3}) {

    
  const rcicolumn =
  localStorage.getItem("teamcode") == "T1"
    ? "35 M %RCI (V)"
    : "35 M %RCI (U)";
const adjustedrciname3 =
  localStorage.getItem("teamcode") == "T1"
    ? "Adj RCI V(" + String(Month3) + ")"
    : "Adj RCI U(" + String(Month3) + ")";

const adjustedrciname2 =
  localStorage.getItem("teamcode") == "T1"
    ? "Adj RCI V(" + String(Month2) + ")"
    : "Adj RCI U(" + String(Month2) + ")";

const adjustedrciname1 =
  localStorage.getItem("teamcode") == "T1"
    ? "Adj RCI V(" + String(Month1) + ")"
    : "Adj RCI U(" + String(Month1) + ")";

const columns = [
        { field: "id", headerName: "ID", width: 40, hide: true, align: "center" },
        {
          field: "rbmcode",
          headerName: "RBM Code",
          width: 130,
          hide: true,
          align: "center",
          renderCell: (params, rowId) => {
            return (
              <p title={params.row.rbmcode} className="ellipsis">
                {params.row.rbmcode}
              </p>
            );
          },
        },
        {
          field: "rbmname",
          headerName: "RBM Name",
          width: 130,
          renderCell: (params, rowId) => {
            return (
              <p title={params.row.rbmname} className="ellipsis">
                {params.row.rbmname}
              </p>
            );
          },
        },
        {
          field: "brand",
          headerName: "Brand",
          width: 80,
          renderCell: (params, rowId) => {
            return (
              <p title={params.row.brand} className="ellipsis">
                {params.row.brand}
              </p>
            );
          },
        },
        {
          field: "prodcode",
          headerName: "Product Code",
          width: 120,
          hide: true,
          renderCell: (params, rowId) => {
            return (
              <p title={params.row.prodcode} className="ellipsis">
                {params.row.prodcode}
              </p>
            );
          },
        },
        {
          field: "proddesc",
          headerName: "Product",
          width: 220,
          renderCell: (params, rowId) => {
            return (
              <p title={params.row.proddesc} className="ellipsis">
                {params.row.proddesc}
              </p>
            );
          },
        },
        {
          field: "rci",
          headerName: rcicolumn,
          width: 80,
          align: "center",
        },
        { field: "median", headerName: "Median", width: 50, align: "center" },
        { field: "maxx", headerName: "Max", width: 50, align: "center" },
        {
          field: "m1_unadjusted_budget_unit",
          headerName: `Unadj.Bud U(${Month1})`,
          width: 100,
          align: "center",
          
        },
        {
          field: "m1_unadjusted_budget_value",
          headerName: `Unadj.Bud V(${Month1})`,
          width: 100,
          align: "center",
          
        },
        {
          field: "m1_plus_minus",
          headerName: `Inc.(${Month1})/Dec.(${Month1})`,
          width: 130,
          align: "center",
        },
        {
          field: "new_defaultvalue1",
          headerName: `%Gr V(${Month1})`,
          width: 100,
          align: "center",
        },
    
        {
          field: "m1_adjusted_budget_unit",
          headerName: `Adj.Bud U(${Month1})`,
          width: 100,
          align: "center",
        },
        {
          field: "m1_adjusted_budget_value",
          headerName: `Adj.Bud V(${Month1})`,
          width: 100,
          align: "center",
        },
        {
          field: "post_budget_adjustment_m1_rci",
          headerName: adjustedrciname1,
          width: 100,
          align: "center",
        },
        {
          field: "m2_unadjusted_budget_unit",
          headerName: `Unadj.Bud U(${Month2})`,
          width: 100,
          align: "center",
          
    
        },
        {
          field: "m2_unadjusted_budget_value",
          headerName: `Unadj.Bud V(${Month2})`,
          width: 100,
          align: "center",
          
    
        },
        {
          field: "m2_plus_minus",
          headerName: `Inc.(${Month2})/Dec.(${Month2})`,
          width: 130,
          align: "center"
        },
        {
          field: "new_defaultvalue2",
          headerName: `%Gr V(${Month2})`,
          width: 100,
          align: "center",
          
        },
        {
          field: "m2_adjusted_budget_unit",
          headerName: `Adj.Bud U(${Month2})`,
          width: 100,
          align: "center",
          
         
        },
        {
          field: "m2_adjusted_budget_value",
          headerName: `Adj.Bud V(${Month2})`,
          width: 100,
          align: "center",
          
    
          
        },
        {
          field: "post_budget_adjustment_m2_rci",
          headerName: adjustedrciname2,
          width: 100,
          align: "center",
        },
        {
          field: "m3_unadjusted_budget_unit",
          headerName: `Unadj.Bud U(${Month3})`,
          width: 100,
          align: "center",
        },
        {
          field: "m3_unadjusted_budget_value",
          headerName: `Unadj.Bud V(${Month3})`,
          width: 100,
          align: "center",
        },
        {
          field: "m3_plus_minus",
          headerName: `Inc.(${Month3})/Dec.(${Month3})`,
          width: 130,
         
        },
        {
          field: "new_defaultvalue3",
          headerName: `%Gr V(${Month3})`,
          width: 100,
          align: "center",
          
        },
        {
          field: "m3_adjusted_budget_unit",
          headerName: `Adj.Bud U(${Month3})`,
          width: 100,
          align: "center",
         
        },
        {
          field: "m3_adjusted_budget_value",
          headerName: `Adj.Bud V(${Month3})`,
          width: 100,
          align: "center",
          
        },
        {
          field: "post_budget_adjustment_m3_rci",
          headerName: adjustedrciname3,
          width: 100,
          align: "center",
          
        },
        {
          field: "rci_guardrail_check_m1",
          headerName: `Response(${Month1})`,
          width: 120,
          align: "center",
          
        },
        {
          field: "rci_guardrail_check_m2",
          headerName: `Response(${Month2})`,
          width: 120,
          align: "center",
    
         
        },
        {
          field: "rci_guardrail_check_m3",
          headerName: `Response(${Month3})`,
          width: 150,
          align: "center",
        },
        {
          field: "reason",
          headerName: "Reason*",
          width: 150,
          align: "center",
        },
        {
          field: "comment",
          headerName: "Additional Comments",
          width: 150,
          align: "center",
        },
      ];    

  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
